module.exports = __webpack_public_path__ + "static/media/nanachi.9dffafa7.jpg";